import { Redirect, useRouteMatch } from 'react-router-dom';

import React from 'react';

export const DefaultRedirect: React.FC = (): JSX.Element => {
  const { url } = useRouteMatch();

  return <Redirect to={`${url}/new`} />;
};
